/**
 * @fileoverview The app root, and the auth provider question it finally answers.
 *
 * PAGES USED THE PLAIN PROVIDER AND THE OPERATOR FOUND OUT WHY THAT WAS WRONG.
 * The header looked like every other Cloistr app's header and did not behave
 * like one: no account switcher, and a person already signed in to Docs or
 * Stash was signed out here. The old reasoning was that the shared provider
 * earns single sign-on by holding first render while it resolves the session,
 * and Pages' main screen is a PUBLIC page that must render for a stranger with
 * no account. Trading the flagship path for a convenience was the wrong way
 * round.
 *
 * WHAT CHANGED IS THAT THE TRADE TURNED OUT NOT TO EXIST. The restore gate is
 * only raised when there is a shared session to restore; a visitor with no
 * `.cloistr.xyz` cookie has nothing to wait for. That is asserted in the browser
 * proof rather than assumed, because the whole argument for staying on the
 * plain provider rested on it and nobody had measured it.
 *
 * THE SIGNER IS REACHED SAME-ORIGIN, through the `/signer/` location in this
 * app's nginx config, exactly as Docs does. The signer sends CORS headers for
 * the key lookup and not for the session endpoint, so a cross-origin call is
 * refused by the browser before it is ever answered. Proxying makes the request
 * same-origin and no preflight is triggered.
 */
import { ThemeProvider } from '@cloistr/ui';
import { SharedAuthProvider } from '@cloistr/ui/components';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.js';
import '@cloistr/ui/styles';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <SharedAuthProvider signerUrl="/signer">
        <App />
      </SharedAuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
